(function ($) {

    var $CCElements,
        $wwFlags,
        $wwCurrentFlagWrapper,
        $wwFlagSelect,
        data;

    $(document).ready(wwDocumentReady);

    function wwDocumentReady() {

        $CCElements = $('.ww-currency-converter');
        $wwFlags = $('#ww-flags');
        $wwCurrentFlagWrapper = $wwFlags.find('div.current-currency');
        $wwFlagSelect = $wwFlags.find('.ww-flags-select');

        $wwCurrentFlagWrapper.click(function () {
            $wwFlags.toggleClass('active');

        });

        $wwFlagSelect.find('li').click(function () {
            setCurrency($(this).data('currency'));
            $wwFlags.removeClass('active');
        });

        $('#masthead').on('mouseleave', function () {
            $wwFlags.removeClass('active');
        });

        // Convert prices after product filter has loaded new ajax content
        $(document).on('woof_ajax_done', function() {
            changePrices();
            console.log($(".woocommerce-products-header"));
            $('html,body').animate({
                scrollTop: $('#woof_results_by_ajax').offset().top - 60},
            500);

            
        });

        

        setCurrency();

    }

    function setCurrency(currency = null) {


        if (currency !== null) {
            $.cookie('currency', currency, {
                expires: 365,
                path: '/'
            });
            setCurrencyFlag(currency);
        }

        $.ajax({
            method: "POST",
            dataType: "json",
            url: phpVars.ajaxurl,
            timeout: 15000,
            data: {
                action: 'ww_currency_conversion',
                nonce: phpVars.ajaxnonce
            },
            complete: function (response) {

                data = response.responseJSON;



                if (typeof data !== 'undefined' && data.success === true) {

                    // Set active selection
                    setCurrencyFlag(data.currency);

                    changePrices();
                    
                    if ( data.currency === 'GBP' ) {
                        
                        $('span.disclaimer').css({opacity:0});
                        
                    } else {
                        $('span.disclaimer').css({opacity:1});
                    }

                }

                $('body').addClass('ww-currency-ready');

            }

        });

    }

    function setCurrencyFlag(currency) {
        // Set active selection
        var flag = $wwFlagSelect.find('.' + currency);
        $wwCurrentFlagWrapper.html(flag.clone());
        $wwFlagSelect.find('img').removeClass('active');
        flag.addClass('active');
    }

    function changePrices() {

        // Too soon
        if ( typeof data == 'undefined' ) {
            return;
        }

        $CCElements = $($CCElements.selector);
        
        $CCElements.each(function () {
            
            var $this = $(this);
            var price = $this.data('price');

            var salePrice = $this.data('sale-price');
            var $output = $this.find('.woocommerce-Price-amount');

            if ( salePrice && salePrice !== price ) {

                var newPrice = (data.conversion * price);
                $this.find('del .woocommerce-Price-amount').html('<span class="woocommerce-Price-currencySymbol">' + data.symbol + '</span>' + newPrice.toFixed(2));
                var newSalePrice = (data.conversion * salePrice);
                $this.find('ins .woocommerce-Price-amount').html('<span class="woocommerce-Price-currencySymbol">' + data.symbol + '</span>' + newSalePrice.toFixed(2));
            } else {
                var newPrice = (data.conversion * price);
                $output.html('<span class="woocommerce-Price-currencySymbol">' + data.symbol + '</span>' + newPrice.toFixed(2));
            }

            var $disclaimer = $('span.disclaimer');
            $disclaimer.find('.currency').html(`${data.currency} (${data.symbol})`);

            if ( data.currency === 'GBP' ) {
                $disclaimer.hide();
            } else {
                $disclaimer.show();
            }

            

            
            // Change component dropdown prices
            $('.component_options_select').each( function() {

                var $this = $(this);
                var wwData = $this.data('ww-data');
                var $options = $this.find('option');
                var offset = 0;

                $options.each( function( index, el ) {

                    var $option = $(this);
                    if ( typeof $option.val() === 'undefined' || $option.val() === '' ) {
                        return;
                    }

                    var option = wwData[offset];
                    var prices = option.option_price_data;

                    var price = prices.regular_price;
                    var salePrice = prices.price;
                    var title = option.option_title;

                    // Sale price
                    if ( salePrice ) {
                        var newPrice = (data.conversion * salePrice);
                        
                        $option.html( title + ' &mdash; ' + data.symbol + newPrice.toFixed(2) );
                    } else {
                        var newPrice = (data.conversion * price);
                        $this.html( title + ' &mdash; ' + data.symbol + newPrice.toFixed(2) );
                    }

                    offset++;

                });
                return;
                
    
            });

        });

        

       
    }

    	
	// Composite plugin
	$( '.composite_data' ).on( 'wc-composite-initializing', function( event, composite ) {

        composite.actions.add_action( 'component_scripts_initialized', (ob) => {

            var optionsData = ob.component_options_model.available_options_data;
            ob.$component_options_select.data('ww-data', optionsData);


            // Add data to totals
            var $totals = ob.composite.$composite_price;
            $totals.addClass('ww-currency-converter');
            var prices = composite.api.get_composite_totals();

            $totals.data('price', prices.regular_price);
            $totals.data('sale-price', prices.price);

            /*
            setInterval(() => {

                
               
            }, 200);*/

            setTimeout(() => {
                var $el = $('.composite_price.ww-currency-converter');
                
                if ( ! $el.hasClass('innitted') ) {
                    $el.addClass('innitted');
                    $el.after( $('.ww-currency-ready .price .disclaimer').first().clone() );
                }
            }, 3000);

           
            

        });




		// Add your code here.
		composite.actions.add_action( 'component_selection_changed', (ob) => {

             // Add data to totals
             var $totals = ob.composite.$composite_price;
             $totals.addClass('ww-currency-converter');
             var prices = composite.api.get_composite_totals();
 
             $totals.data('price', prices.regular_price);
             $totals.data('sale-price', prices.price);

 
            setTimeout(() => {
                changePrices(); 
            }, 10);
            
            //console.log(ob);
            var $componentContent = ob.$component_content;
            /*
			current_configuration = composite.api.get_composite_totals();
			console.log(current_configuration);*/
        }, 2000);



        /*
        composite.filters.add_filter('component_summary_element_content_data', (data) => {
            console.log(data);
            return data;
        });*/

	} );

}(jQuery));

